import { BarLoader, BounceLoader, DotLoader, FadeLoader, HashLoader, MoonLoader, PropagateLoader, PuffLoader, ScaleLoader } from "react-spinners";

const Spinner = () => {
    return (
        <div style={{
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
            }}>
            <div className="p-6 rounded flex flex-col items-center">
                <FadeLoader
                color="#FF3B45"
                speedMultiplier={1}/>
                {/* <p className="mt-2 opacity-60">Downloading</p> */}
            </div>
        </div>
    );
};

export default Spinner;
